export default "__VITE_ASSET__DJhGsGR8__"